// Part of the Chili3d Project, under the AGPL-3.0 License.
// See LICENSE file in the project root for full license information.

import { AppBuilder } from "chili-builder";
import { Logger } from "chili-core";
import { Loading } from "./loading";

let loading = new Loading();
document.body.appendChild(loading);

// prettier-ignore
new AppBuilder()
    .useIndexedDB()
    .useWasmOcc()
    .useThree()
    .useUI()
    .build()
    .then(app => {
        document.body.removeChild(loading);
        // Auto-create a new document for Bitcoin 3D
        app.newDocument("Bitcoin 3D Project");
    })
    .catch((err) => {
        Logger.error(err);
    });
